<div
    class="cmps-cdk-bg-color-white cmps-cdk-border-color-grey-300 cmps-cdk-border-solid cmps-cdk-border-width-1p cmps-cdk-min-w-768px"
>
    <div class="modal-header">
        <div
            class="modal-title h4"
            role="heading"
            aria-level="1"
        >
            {{ _i18n._9537_GOAL_HISTORY_FOR_ | translate }}
            {{ _data?.goal?.metricName }}
        </div>
        <button
            type="button"
            class="close"
            (click)="_dialogRef.close()"
        >
            <cmps-icon svgIcon="close"></cmps-icon>
        </button>
    </div>
    <div class="modal-body">
        <section class="table-historical-goal">
            <div
                *ngIf="_data?.history?.length === 0"
                class="d-flex justify-content-center m-4"
            >
                <div class="no-goal-metric">
                    <cmps-icon svgIcon="information"></cmps-icon>
                    <span class="pl-3">{{
                        _i18n._9538_THERE_IS_NO_GOAL_HISTORY_FOR_THIS_METRIC_
                            | translate
                    }}</span>
                </div>
            </div>
            <div
                class="table-responsive table-goal-history scroll"
                *ngIf="_data?.history?.length !== 0"
            >
                <!-- Table -->
                <table>
                    <thead>
                        <tr>
                            <th class="cmps-goal-history-commitment--miw-100">
                                {{ _i18n._965_DATE | translate }}
                            </th>
                            <th class="cmps-goal-history-commitment--miw-60">
                                {{ _i18n._127_STATUS | translate }}
                            </th>
                            <th class="cmps-goal-history-commitment--miw-100">
                                {{ _i18n._4106_CURRENT_ACTUAL | translate }}
                            </th>
                            <th class="cmps-goal-history-commitment--miw-60">
                                {{ _i18n._721_GOAL | translate }}
                            </th>
                            <th class="cmps-goal-history-commitment--miw-60">
                                {{ _i18n._726_TARGET | translate }}
                            </th>
                            <th class="cmps-goal-history-commitment--miw-60">
                                {{ _i18n._768___TO_TARGET | translate }}
                            </th>
                            <th class="cmps-goal-history-commitment--miw-60">
                                {{ _i18n._9433_START___TO_GOAL | translate }}
                            </th>
                            <th class="cmps-goal-history-commitment--miw-60">
                                {{
                                    _i18n._9534_EXPECTED_IMPROVEMENT___THIS_GOAL
                                        | translate
                                }}
                            </th>
                            <th class="cmps-goal-history-commitment--miw-60">
                                {{
                                    _i18n._9535_CUMULATIVE_EXPECTED_IMPROVEMENT
                                        | translate
                                }}
                            </th>
                            <th class="cmps-goal-history-commitment--miw-150">
                                {{
                                    _i18n._9536_OVERALL_ACTUAL_IMPROVEMENT_SINCE_START_OF_COMMIT
                                        | translate
                                }}
                            </th>
                            <th class="cmps-goal-history-commitment--miw-80">
                                {{ _i18n._9539_GOAL_DUE_DATE | translate }}
                            </th>
                            <th class="cmps-goal-history-commitment--miw-100">
                                {{ _i18n._9813_DAYS_TO_EXP__DATE | translate }}
                            </th>
                            <th class="cmps-goal-history-commitment--miw-100">
                                {{ _i18n._7330_CREATED_BY | translate }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let element of _dataSource">
                            <td class="cmps-goal-history-commitment--miw-100">
                                {{ element.date | date: 'LLL-dd-yyyy' }}
                            </td>
                            <td class="cmps-goal-history-commitment--miw-60">
                                <span [ngClass]="element.textClass">{{
                                    element.expired
                                        ? (_i18n._9809_MISSED | translate)
                                        : element.status
                                }}</span>
                            </td>
                            <td class="cmps-goal-history-commitment--miw-100">
                                {{ element.actual | number: '1.0-2' }}
                            </td>
                            <td class="cmps-goal-history-commitment--miw-60">
                                {{ element.goalValue | number: '1.0-2' }}
                            </td>
                            <td class="cmps-goal-history-commitment--miw-60">
                                {{ element.target | number: '1.0-2' }}
                            </td>
                            <td class="cmps-goal-history-commitment--miw-60">
                                {{ element.percentToTarget | percent: '1.0-2' }}
                            </td>
                            <td class="cmps-goal-history-commitment--miw-60">
                                {{
                                    element.startPercentToGoal
                                        | percent: '1.0-2'
                                }}
                            </td>
                            <td class="cmps-goal-history-commitment--miw-60">
                                {{
                                    element.expectedImprovement
                                        | percent: '1.0-2'
                                }}
                            </td>
                            <td class="cmps-goal-history-commitment--miw-60">
                                {{
                                    element.cumulativeExpectedImprovement
                                        | percent: '1.0-2'
                                }}
                            </td>
                            <td
                                class="cmps-goal-history-commitment--miw-150"
                                [style.color]="
                                    element.overallActualImprovement < 0
                                        ? 'red'
                                        : 'black'
                                "
                            >
                                {{
                                    element.overallActualImprovement
                                        | percent: '1.0-2'
                                }}
                            </td>
                            <td class="cmps-goal-history-commitment--miw-80">
                                {{
                                    element.expectedAchievementDate
                                        | date: 'LLL-dd-yyyy'
                                }}
                            </td>
                            <td class="cmps-goal-history-commitment--miw-100">
                                <span
                                    *ngIf="
                                        element.statusId !==
                                            _GoalStatus.CLOSED &&
                                        element.statusId !==
                                            _GoalStatus.PENDING_CLOSE
                                    "
                                    >{{ element.daysToExpiry }}</span
                                >
                            </td>
                            <td class="cmps-goal-history-commitment--miw-100">
                                <span
                                    *ngIf="
                                        element.statusId !==
                                            _GoalStatus.CLOSED &&
                                        element.statusId !==
                                            _GoalStatus.PENDING_CLOSE &&
                                        element.statusId !== _GoalStatus.DRAFT
                                    "
                                    >{{ element.createdBy }}</span
                                >
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
    </div>
</div>
